import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 22.08c-.3 0-.6-.07-.85-.21-1.87-1.02-5.16-2.1-7.22-2.37l-.29-.04c-1.31-.16-2.39-1.39-2.39-2.72V4.66c0-.79.31-1.51.88-2.03s1.31-.77 2.09-.7c2.2.17 5.52 1.27 7.4 2.45l.24.14c.07.04.22.04.28.01l.16-.1c1.88-1.18 5.2-2.3 7.41-2.49h.12c.73-.07 1.48.19 2.04.71.57.52.88 1.24.88 2.03v12.07c0 1.34-1.08 2.56-2.4 2.72l-.33.04c-2.06.27-5.36 1.36-7.19 2.37-.24.14-.53.2-.83.2M3.98 3.42c-.32 0-.61.11-.84.32-.25.23-.39.56-.39.92v12.08c0 .59.51 1.16 1.08 1.24l.3.04c2.25.3 5.7 1.43 7.7 2.52.09.04.22.05.27.03 2-1.11 5.47-2.25 7.73-2.55l.34-.04c.57-.07 1.08-.65 1.08-1.24V4.67c0-.37-.14-.69-.39-.93-.26-.23-.59-.34-.96-.32h-.12c-1.91.17-4.99 1.2-6.67 2.25l-.16.11c-.55.34-1.33.34-1.86.01l-.24-.14C9.14 4.6 6.06 3.58 4.1 3.42z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 21.24c-.41 0-.75-.34-.75-.75v-15c0-.41.34-.75.75-.75s.75.34.75.75v15c0 .42-.34.75-.75.75m-4.25-12H5.5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2.25c.41 0 .75.34.75.75s-.34.75-.75.75m.75 3h-3c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3c.41 0 .75.34.75.75s-.34.75-.75.75"
    }, null, -1)
  ]))]))
}
export default { render: render }